export function initInspection(doc) {
  return {
    items: doc.items.map((i) => ({ item_id: i.item_id, state: i.state, comment: i.comment || "", photo_id: i.photo_id, criticality: i.criticality })),
    meter_value: doc.meter_value ?? "",
    meter_photo_id: doc.meter_photo_id,
    meter_justification: doc.meter_justification || "",
    view_photos: doc.view_photos || {},
  };
}

export function toPayload(d) {
  return { ...d, meter_value: d.meter_value === "" || d.meter_value === null ? null : Number(d.meter_value) };
}

export function viewsRequired(doc, d) {
  const anomaly = d.items.some((i) => i.state === "anomalie");
  return doc.photo_policy === "always" || anomaly || (doc.photo_policy === "user_change_or_anomaly" && doc.user_change);
}

export function validateInspection(doc, d) {
  const e = {};
  d.items.forEach((it) => {
    const key = `items.${it.item_id}`;
    if (!it.state) e[key] = "Point non renseigné : indiquez Conforme ou Anomalie.";
    else if (it.state === "anomalie") {
      const missing = [];
      if (!it.comment.trim()) missing.push("un commentaire");
      if (!it.photo_id) missing.push("une photo");
      if (!it.criticality) missing.push("la criticité");
      if (missing.length) e[key] = `Anomalie : ajoutez ${missing.join(", ")}.`;
    }
  });
  if (doc.has_meter) {
    const v = d.meter_value === "" ? null : Number(d.meter_value);
    if (v === null || Number.isNaN(v) || v < 0) e.meter_value = "Indiquez la valeur relevée au compteur.";
    else if (doc.previous_meter_value != null && v < doc.previous_meter_value && !d.meter_justification.trim())
      e.meter_value = `Valeur inférieure au relevé précédent (${doc.previous_meter_value}). Corrigez la valeur ou justifiez l'écart.`;
    if (!d.meter_photo_id) e.meter_photo = "Ajoutez la photo du compteur.";
  }
  if (viewsRequired(doc, d)) {
    doc.photo_views.forEach((v) => {
      if (!d.view_photos[v.id]) e[`views.${v.id}`] = `Photo obligatoire : vue « ${v.label} ».`;
    });
  }
  return e;
}
